import _sortBy from "lodash/sortBy";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import isBox from 'swag-common/utils/custom-store-product/product-is-box.util';
import { getVariantSizeNameNotSizeDependent } from 'swag-common/business-logic/custom-store-product/get-variant-size-name.logic';
import checkIsCustomProductApparel from 'swag-common/utils/custom-product/check-is-custom-product-apparel';
import getUniqueSizeSet from '../products/get-unique-size-set.logic';
const getSizeSetWithCount = (product, sizeSet) => {
  if (!product.variants.length) {
    return {};
  }
  const uniqueSizeSettings = getUniqueSizeSet(product.variants[0].boxContent.map(content => _objectSpread({}, content.product.swagProductId, {
    productSize: content.product.sizeSettings,
    sizeId: String(content.product.sizeIndex)
  })));
  const sortedSizeSet = _sortBy(sizeSet, key => Object.keys(uniqueSizeSettings).indexOf(key));
  return sortedSizeSet.reduce((acc, sizeName) => {
    const count = typeof acc[sizeName] === 'undefined' ? 1 : acc[sizeName] + 1;
    return _objectSpread({}, acc, {
      [sizeName]: count
    });
  }, {});
};
const getSizeSet = (variants, isApparelOnly) => {
  const sizeSet = variants.reduce((acc, variant) => {
    let boxContent = variant.boxContent;
    if (isApparelOnly) {
      boxContent = boxContent.filter(boxContent => checkIsCustomProductApparel(boxContent.product, true));
    }
    const colors = boxContent.map(boxContent => getVariantSizeNameNotSizeDependent(boxContent.product)).filter(Boolean);
    return [...acc, ...colors];
  }, []);
  return sizeSet;
};
export const getProductVariationsWithCountApparels = product => {
  const {
    variants
  } = product;
  if (isBox(product.swagProductId)) {
    const sizeSet = getSizeSet(variants, true);
    return getSizeSetWithCount(product, sizeSet);
  }
  return variants.reduce((acc, variant) => {
    const count = typeof acc[variant.sizeIndex] === 'undefined' ? 1 : acc[variant.sizeIndex] + 1;
    return _objectSpread({}, acc, {
      [variant.sizeIndex]: count
    });
  }, {});
};
export const getProductSizeSettingsOptions = product => {
  var _product$sizeSettings;
  if (isBox(product.swagProductId)) {
    const variants = getProductVariationsWithCountApparels(product);
    return Object.keys(variants);
  }
  const sizes = (_product$sizeSettings = product.sizeSettings) === null || _product$sizeSettings === void 0 ? void 0 : _product$sizeSettings.options;
  return sizes || [];
};
export const hasMultipleGiveawayProductSizeVariants = product => {
  return Object.keys(getProductVariationsWithCountApparels(product)).length > 1;
};
export const hasOneGiveawayProductSizeVariants = product => {
  return Object.keys(getProductVariationsWithCountApparels(product)).length === 1;
};
export const getGiveawayProductDefaultSize = product => {
  if (!hasOneGiveawayProductSizeVariants(product)) {
    return '';
  }
  if (isBox(product.swagProductId)) {
    return Object.entries(getProductVariationsWithCountApparels(product))[0][0];
  }
  const variant = product.variants[0];
  const sizeName = getVariantSizeNameNotSizeDependent(variant);
  return sizeName || '';
};